// extracted by mini-css-extract-plugin
module.exports = {"required":"AntCheckbox_required__eFohl","small":"AntCheckbox_small__JKo5b"};